<template>
  <div class="home">
    <div class="topimage">
    <img alt="top-image" src="../assets/topImage.jpg">
    <h2 class="title is-3" style="text-align:center;">あめねこサンプルコード集</h2>
      <p style="text-align:center;font-weight:bold;font-size:1.1em;">Vue.js + Firebaseのコードサンプル集です。</p>
      <p style="margin:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button><a href="https://b.hatena.ne.jp/add?mode=confirm&title=あめねこサンプルコード集&url=https://code.ameneko.com/"><img src="@/assets/hatebu.png" style="margin-left:4px;border-radius:4px;width:36px"></a></p>
    </div>
    <hr style="margin-bottom:5px;">
    <div class="columns">
      <div class="column">
        <h3 class="title is-4">はじめに</h3>
         <div class="parts_block">
          <p><a href="https://www.katonobo.com/entry/start-vuejs" target="_blank">Vue.jsの概要</a><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">そもそもVue.jsとは？という向けのVue.jsの概要と前提の学習条件（ブログ記事）</p>
        </div>
        <div class="parts_block">
          <p><a href="https://www.katonobo.com/entry/vuecli3-setup" target="_blank">Vue.jsのプロジェクト作成</a><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">Vue CLI3で簡単にインストールとプロジェクトのセットアップ（ブログ記事）</p>
        </div>
        <h3 class="title is-4">パーツ</h3>
        <div class="parts_block">
          <p><router-link to="/button-parts-count-up">カウントアップするボタン</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">ボタンを押すと数字を1つ足す機能の実装</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/v-model">v-modelのサンプル</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">双方向バインディングができるv-modelのサンプルコード</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/twitter-share">Twitterシェアボタン</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">Twitterシェアボタンのパーツ</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/class-binding">クラスのバインディング</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">クラスのバインディングする場合のサンプルコード</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/computed-data">computedを使った計算</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">算出プロパティ(computed)を使った計算のサンプルコード</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/for">v-for(forループ)</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">v-for(forループ)のサンプルコード</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/v-if">v-ifを使った例</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">v-ifのサンプルコード</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/router-watch/first">ウォッチャーを使った画面遷移検出</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">ウォッチャーを使った画面遷移検出のサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/window-size">画面サイズを検出して表示を変えるサンプル</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">画面サイズを検出して表示を変えるサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/sort">並び替え（sort）サンプル</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">並び替え（sort）サンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/transition">トランジションのサンプル</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">アニメーションのトランジションのサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/input-database">firestoreにデータインプットするサンプル</router-link><b-tag style="font-size:0.7em;">Vue</b-tag><b-tag style="font-size:0.7em;">Firebase</b-tag></p>
          <p style="font-size:0.9em;">FirebaseのFirestoreにデータを登録する場合のサンプルコードです</p>
        </div>
      </div>
      <div class="column">
        <h3 class="title is-4">アプリ</h3>
        <div class="parts_block">
          <p><router-link to="/bmi-maker">BMI計算アプリ</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">BMIを計算するアプリです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/janken">じゃんけんアプリ</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">じゃんけんアプリのサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/shopping">買い物リストのアプリ</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">買い物リストのサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/omikuji">おみくじアプリ</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">おみくじアプリのサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/mojisu">文字数カウントのアプリ</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">文字数カウントのアプリのサンプルコードです</p>
        </div>
        <div class="parts_block">
          <p><router-link to="/chat">チャットアプリのアプリ</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">チャットアプリのサンプルコードです</p>
        </div>
      </div>
      <div class="column">
        <h3 class="title is-4">応用</h3>
        <div class="parts_block">
          <p><router-link to="/head-meta-change">head要素のtitleとdescriptionの書き換え</router-link><b-tag style="font-size:0.7em;">Vue</b-tag></p>
          <p style="font-size:0.9em;">SEO対策に、head要素のtitleとdescriptionをページごとに書き換えるサンプルコードです</p>
        </div>
      </div>
    </div>
  <p style="text-align:center;font-weight:bold;font-size:0.9em;">毎日１つ更新目標でやっています。ご意見ご要望は<a href="https://twitter.com/katonobo1" target="_blank">かとのぼ</a>まで</p>
  </div>
</template>

<script>

export default {
  name: 'home',
  mounted(){
    const title = "VueとFirebaseコード集｜あめねこサンプルコード集"
    const description = "VueとFirebaseのサンプルコードに特化したサイト。あめねこサンプルコード集では、一つのページで動作確認とサンプルコードが閲覧ができるため初心者や入門者にもわかりやすくなっています。"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  methods:{
    twitterShare(){
      var shareURL = 'https://twitter.com/intent/tweet?text=' + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/";  
      location.href = shareURL
    },
  } 

}
</script>

<style scoped>
.topimage {
  position: relative;
}
.topimage h2{
  position: absolute;
  top: 40%; 
  left:50%; 
  margin:0;
  padding:0;
  color: white;/*文字は白に*/
  font-weight: bold; /*太字に*/
  font-size: 1.8em;
  font-weight: bold;
  z-index: 1;
}
.topimage img {
  width: 100%;
  max-height: 750px;
}

.columns{
  max-width: 1200px;
  margin: auto;
  padding: 10px;
}
router-link{
  font-weight: bold;
}
a {
    color:#1F9CEE;
}
.parts_block{
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: dotted 1px gray;
}
.title{
  margin: 16px 0 16px 0;
}
a{
  font-size:1.1em;
}

</style>
